module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-container"
  }, [(_vm.$store.state.is_manager) ? _c('div', {
    staticClass: "edit-document-button"
  }, [_c('el-button', {
    staticClass: "circle-button",
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit",
      "title": "编辑"
    },
    on: {
      "click": _vm.editorDocument
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "el-link el-link--danger is-underline",
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = true
      }
    }
  }, [_c('span', {
    staticClass: "el-link--inner"
  }, [_vm._v("如果图片无法显示，请点击。（Click here to refresh the image.）")])]), _vm._v(" "), _c('div', {
    staticClass: "document-title"
  }, [_c('p', {
    staticClass: "documentTitle",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    ref: "contentWrapper",
    staticClass: "document-content"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "学城图片认证（Citadel Image Verification）",
      "visible": _vm.centerDialogVisible,
      "width": "500px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('iframe', {
    staticClass: "iframe",
    attrs: {
      "src": "https://km.sankuai.com/api/file/cdn/277659316/277785340?contentType=1&isNewContent=true&isNewContent=false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "success-message"
  }, [_vm._v("认证成功（Verified）")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeDialogFun
    }
  }, [_vm._v("确 定（Confirm）")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f6899ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templateHtml.vue
// module id = 634
// module chunks = 1